// extracted by mini-css-extract-plugin
module.exports = {"ContactLinks":"ContactLinks_ContactLinks__1hcOW"};